import { lazy } from 'react';

// Lazy loading de componentes públicos
const Login = lazy(() => import('../Containers/Login'));
const RecoverAccount = lazy(() => import('../Containers/RecoverAccount'));
const RecoverPassword = lazy(() => import('../Containers/RecoverPassword'));
const RecoverEmail = lazy(() => import('../Containers/RecoverEmail'));
const RecoverReset = lazy(() => import('../Containers/RecoverReset'));
const RecoverSuccess = lazy(() => import('../Containers/RecoverSuccess'));
const Register = lazy(() => import('../Containers/Register'));
const RegisterSuccess = lazy(() => import('../Containers/RegisterSuccess'));
const RegisterValidation = lazy(() => import('../Containers/RegisterValidation'));
const Terminos = lazy(() => import('../Containers/Terminos'));
const LoginAdmin = lazy(() => import('../Containers/LoginAdmin'));
const Tools = lazy(() => import('../Containers/Tools'));
const Tutoriales = lazy(() => import('../Containers/Tutoriales'));
const TableTest = lazy(() => import('../Containers/TableTest'));

export const publicRoutes = [
  {
    path: '/login',
    component: Login,
    breadcrumb: 'Login',
    exact: true
  },
  {
    path: '/admin',
    component: LoginAdmin,
    breadcrumb: 'Login',
    exact: true
  },
  {
    path: '/tools',
    component: Tools,
    breadcrumb: 'Herramientas'
  },
  {
    path: '/recover-account',
    component: RecoverAccount,
    breadcrumb: 'Recover Account'
  },
  {
    path: '/recover-password',
    component: RecoverPassword,
    breadcrumb: 'Recover Password'
  },
  {
    path: '/recover-email',
    component: RecoverEmail,
    breadcrumb: 'Recover Email'
  },
  {
    path: '/recover-reset',
    component: RecoverReset,
    breadcrumb: 'Recover Reset'
  },
  {
    path: '/recover-success',
    component: RecoverSuccess,
    breadcrumb: 'Recover Success'
  },
  {
    path: '/register',
    component: Register,
    breadcrumb: 'Register'
  },
  {
    path: '/register-success',
    component: RegisterSuccess,
    breadcrumb: 'Register Success'
  },
  {
    path: '/register-validation',
    component: RegisterValidation,
    breadcrumb: 'Register Validation'
  },
  {
    path: '/terminos',
    component: Terminos,
    breadcrumb: 'Terminos y condiciones'
  },
  {
    path: '/tutoriales',
    component: Tutoriales,
    breadcrumb: 'Tutoriales'
  },
  {
    path: '/table-test',
    component: TableTest,
    breadcrumb: 'Table Test'
  },
];
